import { getCardTypeByValue } from "../validator/card-types-selector";
export var formatCardNumber = function (cardNumber) {
    var cardType = getCardTypeByValue(cardNumber);
    if (!cardType)
        return (cardNumber.match(/\d+/g) || []).join('');
    var format = cardType.format;
    if (format && format.global) {
        var formatted = (cardNumber.match(format) || []).join(' ');
        return (cardNumber.match(format) || []).join(' ');
    }
    if (format) {
        var execResult = format.exec(cardNumber.split(' ').join(''));
        if (execResult) {
            return execResult
                .splice(1, 3)
                .filter(function (x) { return x; })
                .join(' ');
        }
    }
    return cardNumber;
};
export var hasCardNumberReachedMaxLength = function (currentValue) {
    var cardType = getCardTypeByValue(currentValue);
    return cardType && currentValue.length >= cardType.lengths[cardType.lengths.length - 1];
};
export var formatExpiry = function (event) {
    var eventData = event.nativeEvent && 'data' in event.nativeEvent ? event.nativeEvent.data : null;
    var prevExpiry = event.target.value.split(' / ').join('/');
    if (!prevExpiry)
        return null;
    var expiry = prevExpiry;
    if (/^[2-9]$/.test(expiry)) {
        expiry = "0".concat(expiry);
    }
    if (prevExpiry.length === 2 && +prevExpiry > 12) {
        var _a = prevExpiry.split(''), head = _a[0], tail = _a.slice(1);
        expiry = "0".concat(head, "/").concat(tail.join(''));
    }
    if (/^1[/-]$/.test(expiry)) {
        return "01 / ";
    }
    var expiryTest = expiry.match(/(\d{1,2})/g) || [];
    if (expiryTest.length === 1) {
        if (!eventData && prevExpiry.includes('/')) {
            return expiryTest[0];
        }
        if (/\d{2}/.test(expiryTest[0])) {
            return "".concat(expiryTest[0], " / ");
        }
    }
    if (expiryTest.length > 2) {
        var _b = expiryTest.join('').match(/^(\d{2}).*(\d{2})$/) || [], _c = _b[1], month = _c === void 0 ? null : _c, _d = _b[2], year = _d === void 0 ? null : _d;
        return [month, year].join(' / ');
    }
    return expiryTest.join(' / ');
};
